import { CommonModule } from '@angular/common';
import {
  RouterOutlet,
  RouterLink,
  RouterModule,
  Router,
  NavigationEnd,
} from '@angular/router';
import {
  Component,
  ElementRef,
  HostListener,
  OnInit,
  ViewChild,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { SidebarComponent } from './modules/core/components/sidebar/sidebar.component';
import { socket } from './modules/shared/helpers/socketio';
import { ToastComponent } from './modules/shared/toast/toast/toast.component';
import { TokenService } from './modules/shared/services/token.service';
import { ToastrService } from 'ngx-toastr';
import { ProfileService } from './modules/shared/services/profile.service';
import { PiecePromotionComponent } from './modules/shared/piece-promotion/piece-promotion.component';
import { NetworkStatusServiceService } from './modules/shared/services/network-status.service.service';
import { FooterComponent } from './modules/core/components/footer/footer.component';
import { DecryptionService } from './modules/shared/services/decryption.service';

interface sideNavToggle {
  screenWidth: number;
  collapsed: boolean;
}

@Component({
  selector: 'app-root',
  standalone: true,
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  imports: [
    CommonModule,
    RouterOutlet,
    FormsModule,
    SidebarComponent,
    RouterLink,
    RouterModule,
    ToastComponent,
    PiecePromotionComponent,
    FooterComponent,
  ],
})
export class AppComponent implements OnInit {
  isSideNavCollapsed = false;
  screenWidth = 0;
  url: any;
  sidenavShow = false;
  toster: boolean = true;
  routerName!: string | null;
  scrollSection = '';
  resposiveSection: boolean = true;
  isHomePage: boolean = false;
  username: any;
  @ViewChild('dataContainer', { static: false }) dataContainer!: ElementRef;

  @HostListener('window:beforeunload', ['$event'])
  unloadHandler($event: any): void {
    socket.disconnect();
  }
  constructor(
    private route: Router,
    private token: TokenService,
    private toastr: ToastrService,
    private networkStatus: NetworkStatusServiceService
  ) {
    this.boardUpdate();
  }

  ngOnInit(): void {
    let currentUser = JSON.parse(localStorage.getItem('loggedInUser') || '{}');
    this.networkStatus.isOnline().subscribe((online) => {
      if (online) {
        socket.emit('online', currentUser.username);
      } else {
        socket.disconnect();
      }
    });

    if (currentUser.token) {
      this.token.tokenCheck().subscribe({
        next: (response) => {},
        error: (error: any) => {
          this.toastr.error(
            'Your session has expired. <br> <a href="/login">Log in again</a>',
            'Session Timeout',
            {
              enableHtml: true,
              closeButton: true,
              timeOut: 5000,
            }
          );
          localStorage.clear();
          this.route.navigate(['/play']);
        },
      });
    }

    let gameId = JSON.parse(localStorage.getItem('gameIdreponse') || '{}');

    this.route.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.getCurrentRoute();
        this.isHomePage = this.route.url === '/';
        if (this.url == `/play/${gameId._id}`) {
          this.toster = false;
        }
      }
    });
  }

  onScroll(e: any, scroll: any) {
    scroll.scrollTop = 0;
  }

  onToggleSideNav(data: sideNavToggle) {
    this.screenWidth = data.screenWidth;
    this.isSideNavCollapsed = data.collapsed;
  }

  getCurrentRoute() {
    this.url = this.route.url;
    if (this.url == '/signup' || this.url == '/login') {
      this.sidenavShow = false;
      this.scrollSection = 'scrollbar-manu-show';
    } else {
      this.sidenavShow = true;
      this.scrollSection = 'scrollbar-manu';
    }
    this.resposiveSection = this.route.url === '/';
  }

  boardUpdate() {
    let boardPiece: any = localStorage.getItem('boardPieces');
    let boardData = JSON.parse(boardPiece);

    document.documentElement.style.setProperty(
      '--local-storage-oddcolor',
      boardData?.white || '#f0d9b5'
    );
    document.documentElement.style.setProperty(
      '--local-storage-color',
      boardData?.black || '#b58863'
    );
    if (!boardData) {
      this.boardapidata();
    }
  }

  boardapidata() {
    let boardData = {
      black: '#b58863',
      white: '#f0d9b5',
      theme: 'Classic',
      pieces: 'wikipedia',
    };
    localStorage.setItem('boardPieces', JSON.stringify(boardData));
  }
}
